import React, { useState, useEffect } from "react";
import DynamicTable from "@atlaskit/dynamic-table";
import { useDispatch, useSelector } from "react-redux";
import { defaultHTTPHeaders, httpHeaderTableHead } from "../../../../../common/constants/core/integration.constants";
import uuid from "react-uuid";
import AddIcon from "@atlaskit/icon/core/add";
import DeleteIcon from "@atlaskit/icon/core/delete";
import Button from "@atlaskit/button/new";
import Tooltip from "@atlaskit/tooltip";
import { setEditorSaved } from "../../../../../redux/actions/integrationActions";
import HeaderKey from "./HeaderKey";
import { Collapse } from "antd";
import CellTextField from "../../../../../common/components/CellTextField";

const HTTPHeaders = ({ action }) => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const { Panel } = Collapse;
  const render = useSelector((state) => state.integration.render);

  useEffect(() => {
    if (action && action.headers) {
      setRows(getRows());
    } else {
      setRows([]);
    }
  }, [action, render]);

  const createRow = (item, index) => ({
    cells: [
      {
        content: <HeaderKey headerKey={item.key} index={index} onChange={onChangeHeader} headerOptions={getSelectableHeaderOptions(index)} />,
        key: uuid(),
      },
      { content: <CellTextField inputValue={item.value} index={index} onChange={onChangeHeader} type="VALUE" />, key: uuid() },
      {
        content: getButton(index),
        key: uuid(),
      },
    ],
  });
  const getButton = (index) => {
    return (
      <Tooltip key="remove-header" content="Remove Header">
        <Button onClick={() => onRemoveHeader(index)} iconBefore={DeleteIcon} aria-label="Remove Header" />
      </Tooltip>
    );
  };
  const onChangeHeader = (value, index, type) => {
    switch (type) {
      case "KEY":
        action.headers[index].key = value;
        setRows(getRows());
        break;
      case "VALUE":
        action.headers[index].value = value;
        break;
      default:
        break;
    }
    dispatch(setEditorSaved(false));
  };

  const getHeaderOptions = () => {
    const optionsByValue = new Map(defaultHTTPHeaders.map((header) => [header.value, header]));
    (action?.headers || []).forEach((header) => {
      if (header?.key) {
        optionsByValue.set(header.key, { label: header.key, value: header.key });
      }
    });
    return Array.from(optionsByValue.values());
  };

  const getSelectableHeaderOptions = (index) => {
    const usedKeys = new Set(
      (action?.headers || [])
        .filter((header, headerIndex) => headerIndex !== index && header?.key)
        .map((header) => header.key)
    );

    return getHeaderOptions().filter((option) => !usedKeys.has(option.value));
  };

  const getRows = () => {
    if (action && action.headers) {
      return action.headers.map((h, i) => createRow(h, i));
    }
    return [];
  };
  const onAddHeader = () => {
    action.headers ? action.headers.push({ key: "", value: "" }) : (action.headers = [{ key: "", value: "" }]);
    setRows(getRows());
    dispatch(setEditorSaved(false));
  };
  const onRemoveHeader = (index) => {
    if (index > -1) {
      action.headers.splice(index, 1);
      setRows(getRows());
      dispatch(setEditorSaved(false));
    }
  };

  return (
    <>
      <Collapse defaultActiveKey={[]} ghost>
        <Panel header="HTTP Headers" key="1">
          <DynamicTable head={httpHeaderTableHead} rows={rows ? rows : []} />
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
            <Button onClick={onAddHeader} iconBefore={AddIcon}>
              Add Header
            </Button>
          </div>
        </Panel>
      </Collapse>
    </>
  );
};

export default HTTPHeaders;
